<template>
  <div class="col-12">
    <div id="search-row" class="row justify-content-center backrgoundColoring">
      <div class="col-lg-7 col-md-11">
        <!-- CLASSICAL / COLLOQUIAL SELECTOR BUTTONS-->
        <div style="text-align: center">
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary btn-sm"
              :class="{ active: colloquial === 'no' }"
              for="option1"
              @click="setClassical()"
            >
              <input
                type="radio"
                name="options"
                id="option1"
                value="no"
                autocomplete="off"
                v-model="colloquial"
              />
              Classical
            </label>
            <label
              class="btn btn-outline-secondary btn-sm"
              :class="{ active: colloquial === 'yes' }"
              for="option2"
              @click="setColloquial()"
            >
              <input
                type="radio"
                name="options"
                id="option2"
                value="yes"
                autocomplete="off"
                v-model="colloquial"
              />
              Colloquial
            </label>
          </div>
        </div>

        <!-- TEXT INPUT AND SUBMIT -->
        <div id="search-column">
          <form
            style="margin: 0 auto"
            @submit.prevent="handleSubmit"
            autocomplete="off"
          >
            <div class="form-group">
              <div class="input-group flex-wrap search-input-container" style="width: 90%; margin: 0 auto">
                <input
                  v-on:input="handleChange"
                  v-on:change="handleChange"
                  v-on:keydown="handleSearchInputKeydown"
                  v-model="searchText"
                  type="text"
                  class="form-control search-input-box"
                  v-bind:class="{ 'large-font': largeFont }"
                  id="searchInput"
                  aria-describedby="searchInput"
                  placeholder="Search..."
                  ref="searchInput"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                />
                <div class="input-group-append search-type-dropdown" ref="searchTypeDropdown">
                    <button ref="dropdownButton" class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{searchTypeText}}</button>
                    <div v-if="colloquial === 'no'" class="dropdown-menu">
                        <div v-if="showRecentSearchTypes && filteredRecentClassicalSearchTypes.length > 0" >
                            <span class="dropdown-item recent-searches-dropdown-label"v>Recent searches:</span>
                            <div v-for="(_type, i) in filteredRecentClassicalSearchTypes" :key="'_type_'+i">
                              <!-- We want to skip the first one, zero, bc that's the current search type -->
                                <a class="dropdown-item" href="#" @click="updateSearchType(_type);">{{ getSearchTypeText(_type) }}</a>
                            </div>
                            <div class="dropdown-divider"></div>
                        </div>
                          <a v-if="shouldShowClassicalSearch('fulltext')" class="dropdown-item" :class="{ active: searchType === 'fulltext' }" href="#" @click="updateSearchType('fulltext');">Full text</a>
                          <a v-if="shouldShowClassicalSearch('fulltext-all-fields')" class="dropdown-item" :class="{ active: searchType === 'fulltext-all-fields' }" href="#" @click="updateSearchType('fulltext-all-fields');">Full text (all fields)</a>
                          <a v-if="shouldShowClassicalSearch('englishDefinition')" class="dropdown-item" :class="{ active: searchType === 'englishDefinition' }" href="#" @click="updateSearchType('englishDefinition');">English/Definition</a>
                          <div v-if="shouldShowClassicalSearch('definiendu') || shouldShowClassicalSearch('definiendumStarts') || shouldShowClassicalSearch('definiendumExact')" class="dropdown-divider"></div>
                          <a v-if="shouldShowClassicalSearch('definiendum')" class="dropdown-item" :class="{ active: searchType === 'definiendum' }" href="#" @click="updateSearchType('definiendum');">Defined Term (contains)</a>
                          <a v-if="shouldShowClassicalSearch('definiendumStarts')" class="dropdown-item" :class="{ active: searchType === 'definiendumStarts' }" href="#" @click="updateSearchType('definiendumStarts')">Defined Term (begins with)</a>
                          <a v-if="shouldShowClassicalSearch('definiendumExact')" class="dropdown-item" :class="{ active: searchType === 'definiendumExact' }" href="#" @click="updateSearchType('definiendumExact')">Defined Term (exact)</a>
                          <div v-if="shouldShowClassicalSearch('translation-tool') || shouldShowClassicalSearch('verb-tense')" class="dropdown-divider"></div>
                          <a v-if="shouldShowClassicalSearch('translation-tool')"" class="dropdown-item" :class="{ active: searchType === 'translation-tool' }" href="#" @click="updateSearchType('translation-tool');">Translation Tool</a>
                          <a v-if="shouldShowClassicalSearch('verb-tense')" class="dropdown-item" :class="{ active: searchType === 'verb-tense' }" href="#" @click="updateSearchType('verb-tense');">Verb Tense</a>
                          <div v-if="shouldShowClassicalSearch('definiendumLike') || shouldShowClassicalSearch('definiendumRegex')">
                              <div class="dropdown-divider"></div>
                              <a v-if="shouldShowClassicalSearch('definiendumLike')" class="dropdown-item" :class="{ active: searchType === 'definiendumLike' }" href="#" @click="updateSearchType('definiendumLike')">Definiendum (LIKE)</a>
                              <a v-if="shouldShowClassicalSearch('definiendumRegex')" class="dropdown-item" :class="{ active: searchType === 'definiendumRegex' }" href="#" @click="updateSearchType('definiendumRegex')">Definiendum (regex)</a>
                          </div>
                    </div>
                    <div v-if="colloquial === 'yes'" class="dropdown-menu">
                        <a v-if="enabledSearchTypes['monlam-englishToTibetan']" class="dropdown-item" :class="{ active: searchType === 'monlam-englishToTibetan' }" href="#" @click="updateSearchType('monlam-englishToTibetan');">Eng. to <span style="font-size: 150%">བོད་</span></a>
                        <a v-if="enabledSearchTypes['monlam-tibetanToEnglish']" class="dropdown-item" :class="{ active: searchType === 'monlam-tibetanToEnglish' }" href="#" @click="updateSearchType('monlam-tibetanToEnglish');"><span style="font-size: 150%">བོད་</span> to Eng.</a>
                        <a v-if="enabledSearchTypes['monlam-tibetanToTibetan']" class="dropdown-item" :class="{ active: searchType === 'monlam-tibetanToTibetan' }" href="#" @click="updateSearchType('monlam-tibetanToTibetan');"><span style="font-size: 150%">སྨོན་ལམ་ཚིག་མཛོད་ཆེན་མོ།</span> 2021</a>
                        <a v-if="enabledSearchTypes['monlam-tibetanToTibetanOld']" class="dropdown-item" :class="{ active: searchType === 'monlam-tibetanToTibetanOld' }" href="#" @click="updateSearchType('monlam-tibetanToTibetanOld');"><span style="font-size: 150%">སྨོན་ལམ་ཚིག་མཛོད་ཆེན་མོ།</span> 2016</a>
                    </div>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="colloquial == 'yes'">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="beginsWith"
                  :checked="containsOrBeginsWith === 'beginsWith'"
                  v-model="containsOrBeginsWith"
                  @change="handleContainsOrBeginsWith"
                />
                <label class="form-check-label" for="inlineRadio1"
                  >Begins With</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="contains"
                  :checked="containsOrBeginsWith === 'contains'"
                  v-model="containsOrBeginsWith"
                  @change="handleContainsOrBeginsWith"
                />
                <label class="form-check-label" for="inlineRadio2"
                  >Contains</label
                >
              </div>
            </div>
            <div class="form-group"
              v-if="colloquial === 'yes' && (searchType === 'monlam-tibetanToTibetan' || searchType === 'monlam-tibetanToTibetanOld')">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="search-definition" name="search-definition"
                  value="yes" v-model="searchDefinitionAsWellAsTerm" />
                <label class="form-check-label" for="search-definition">
                  Search within definition as well definiendum</label>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-primary">Submit</button>
              <button class="btn btn-outline-danger search-reset" @click="clearSearch">
                <font-awesome-icon icon="undo" />
              </button>
              <div class="search-type-explanation" v-if="getSearchTypeExplanation()">
                {{ getSearchTypeExplanation() }}
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- WYLIE -->
      <div class="col-lg-5 col-md-11" id="wylie-container" v-if="showWylie">
        <WylieReference :clickWylie="clickWylie" />
      </div>
    </div>

    <!-- RESULTS INFO ROW -->
    <div style="text-align: center">
      <div v-if="this.results">
        Number of results: {{ this.results.length }}
      </div>
      <div v-if="resultsTime">{{ resultsTime }}</div>
    </div>
  </div>
</template>

<!-- eslint-disable no-control-regex -->
<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
  import WylieReference from '../components/WylieReference';

  export default {
    name: 'SearchInputBox',
    components: {
        WylieReference
    },
    props: {
        handleSubmit: Function, // call the submit function
        clearResults: Function, // should set results = []
        handleClearSearch: Function, // needs to be passed from parewnt
        getSearchTypeText: Function, // this should prob be refactored
        results: [Array, String],
        resultsTime: [String, Boolean],
    },
    data: () => {
      return {
        searchTypeDropdownOpen: false, // Track if dropdown is open
        searchTypeDropdownExpanded: false, // Track if expanded to show all types
        showAllSearches: false
      }
    },
    async mounted() {
        console.log("colloquial on mount="+this.colloquial)
        console.log("enabledSearchTypes on mount:" + JSON.stringify(this.enabledSearchTypes) )
        console.log("recentClassicalSearchTypes:", this.recentClassicalSearchTypes)
    },
    computed: {
      ...mapState('app', [
        'enabledSearchTypes',
      ]),
      ...mapState('user', [
      ]),
      showWylie: {
        get () { return this.$store.state.app.showWylie},
        set (value) { this.setShowWylie(value) }
      },
      searchText: {
        get() {
          return this.$store.state.app.searchText;
        },
        set(value) {
          //this.$store.commit('app/setSearchText', value);
          if (typeof value === 'string' || value instanceof String) {
            this.setSearchText(value.trim())
          }
          else {
            this.setSearchText(value)
          }
        }
      },
      searchTypeText: {
        get() {
          return this.$store.state.app.searchTypeText;
        },
        set(value) {
          this.$store.commit('app/setSearchTypeText', value);
        }
      },
      showRecentSearchTypes: {
        get() {
          return this.$store.state.app.showRecentSearchTypes;
        },
        set(value) {
          this.$store.commit('app/setShowRecentSearchTypes', value);
        }
      },
      colloquial: {
        get() {
          return this.$store.state.app.colloquial;
        },
        set(value) {
          this.$store.commit('app/setColloquial', value);
        }
      },
      isColloquial() {
        return this.colloquial === 'yes';
      },
      isClassical() {
        return this.colloquial === 'no';
      },
      searchType: {
        get() {
          return this.$store.state.app.searchType;
        },
        set(value) {
          this.$store.commit('app/setSearchType', value);
        }
      },
      containsOrBeginsWith: {
        get() {
          return this.$store.state.app.containsOrBeginsWith;
        },
        set(value) {
          console.log("Setting translation tool text area font size to", value);
          // Commit a mutation or dispatch an action to update the store
          this.$store.commit('app/containsOrBeginsWith', value);
        }
      },
      largeFont: function () {
        return this.searchText && this.containsTibetanChars(this.searchText);
      },
      hasSearchHistory() {
        // Check if user has enough search history to show compact view
        return this.$store.state.app.searchTypeHistory.length > 2;
      },
      searchTypeHistory() {
        return this.$store.state.app.searchTypeHistory || [];
      },
      recentClassicalSearchTypes() {
        // Return the 4 most recent search types that are enabled
        console.log("searchTypeHistory:", this.searchTypeHistory)
        const results = this.searchTypeHistory.filter(type => !type.includes('monlam')).slice(0, 3);
        console.log("recentClassicalSearchTypes:", results)
        return results;
      },
      filteredRecentClassicalSearchTypes() { 
        console.log("searchTypeHistory:", this.searchTypeHistory)
        const filtered = this.recentClassicalSearchTypes.filter(type => type != this.searchType)
        console.log("filteredRecentClassicalSearchTypes:", filtered)
        return filtered;
      },
    },
    methods: {
        ...mapMutations('app', [
            'setSearchText',
            'setSearchTypeText',
            'setSearchType',
        ]),
        containsTibetanChars(string) { // TODO move to library
            return string.match(/[\u0F00-\u0FFF]+/g);
        },
        clickWylie(wylie) {
            this.setSearchText(this.searchText+=wylie);
            this.$refs.searchInput.focus();
        },
        updateSearchType(type) {
            console.log("Updating search type to:", type)
            if (type === "definiendumRegex") {
                const response = prompt("Regex searches can cause problems. Please enter the password.")
                if (response !== "please") return
            }
            this.$log.debug("Search Type = " + type);
            this.clearResults();
            this.searchType = type;
            this.searchTypeText = this.getSearchTypeText(type);
            this.searchTypeDropdownOpen = false; // Close entire dropdown
            this.searchTypeDropdownExpanded = false; // Reset expanded state
        },
        toggleSearchTypeDropdown() {
            console.log("Toggle search type dropdown")
            this.searchTypeDropdownOpen = !this.searchTypeDropdownOpen;
        },
        expandSearchTypeDropdown() {
            console.log("Expand search type dropdown")
            this.searchTypeDropdownExpanded = true;
        },
        handleContainsOrBeginsWith() {
            // do side effects, not needed
        },
        handleChange() {

            //this.largeFont = this.searchText.match(/[^\u0000-\u007F]+/g);

            if (this.searchText == '' || this.searchText.length <= 2 || this.searchType === 'definiendumRegex' || this.searchType === 'definiendumGetRegexMatches') {
            this.clearResults()
            }

        },
        clearSearch(){
          this.setSearchText("");
          this.handleClearSearch();
      },
        setColloquial() {
            this.colloquial = "yes";
            this.clearResults();
            this.updateSearchType('monlam-englishToTibetan');
            this.$log.debug("setColloquial()");
        },
        setClassical() {
            this.colloquial = "no";
            this.clearResults();
            this.updateSearchType('fulltext');
            this.$log.debug("setClassical()");
        },
        handleSearchInputKeydown(event) {
            // Only handle arrow up/down keys
            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
            return;
        }

        // Prevent default behavior (cursor movement)
        event.preventDefault();

        // Get available search types based on current mode (classical/colloquial)
        let availableSearchTypes = [];

        if (this.colloquial === 'no') {
          // Classical search types in order
          const classicalTypes = [
            'fulltext',
            'fulltext-all-fields',
            'englishDefinition',
            'definiendum',
            'definiendumStarts',
            'definiendumExact',
            'translation-tool',
            'verb-tense',
            'definiendumLike',
            'definiendumRegex'
          ];
          availableSearchTypes = classicalTypes.filter(type => this.enabledSearchTypes[type]);
        } else {
          // Colloquial search types in order
          const colloquialTypes = [
            'monlam-englishToTibetan',
            'monlam-tibetanToEnglish',
            'monlam-tibetanToTibetan',
            'monlam-tibetanToTibetanOld'
          ];
          availableSearchTypes = colloquialTypes.filter(type => this.enabledSearchTypes[type]);
        }

        // Find current index
        const currentIndex = availableSearchTypes.indexOf(this.searchType);

        if (currentIndex === -1) {
          // Current search type not in list, set to first available
          if (availableSearchTypes.length > 0) {
            this.updateSearchType(availableSearchTypes[0]);
          }
          return;
        }

        // Calculate new index
        let newIndex;
        if (event.key === 'ArrowDown') {
          newIndex = (currentIndex + 1) % availableSearchTypes.length;
        } else {
          newIndex = (currentIndex - 1 + availableSearchTypes.length) % availableSearchTypes.length;
        }

        // Update search type
        this.updateSearchType(availableSearchTypes[newIndex]);
      },
      getSearchTypeExplanation() {
        const explanations = {
          fulltext: 'Searches across all primary fields including Tibetan, English, Sanskrit, and definitions.',
          'fulltext-all-fields': 'Searches across all fields including additional metadata fields such as comments.',
          definiendum: 'Searches for words that contain your search text in the Tibetan/Wylie definiendum (defined term) field.',
          englishDefinition: 'Searches only in English definitions and explanations.',
          definiendumStarts: 'Searches for words that begin with your search text in the definiendum (defined term) field.',
          definiendumExact: 'Searches for an exact match of your search text in the definiendum (defined term) field.',
          definiendumLike: 'Searches using SQL LIKE pattern matching in the definiendum (defined term) field.',
          definiendumRegex: 'Searches using regular expressions for advanced pattern matching.',
          'translation-tool': 'Breaks down Tibetan text word by word and finds definitions for each component. Uses a relatively dumb algorithm so word breaks not guaranteed to be correct.',
          'verb-tense': 'Searches for verb tense information and conjugations.',
          'monlam-englishToTibetan': 'Translates from English to Tibetan using the Monlam dictionary.',
          'monlam-tibetanToEnglish': 'Translates from Tibetan to English using the Monlam dictionary.',
          'monlam-tibetanToTibetan': 'Searches the 2021 Monlam Tibetan-to-Tibetan dictionary.',
          'monlam-tibetanToTibetanOld': 'Searches the 2016 Monlam Tibetan-to-Tibetan dictionary.'
        };
        return explanations[this.searchType] || null;
      },
      shouldShowClassicalSearch(type) {
        // user can toggle this feature on and off
        if (this.showRecentSearchTypes) {
        return this.enabledSearchTypes[type] && !this.recentClassicalSearchTypes.includes(type)
        } 
        else {
          return this.enabledSearchTypes[type]
        }
      },
      isEnabledSearchType(type) {
        console.log("isEnabledSearchType: "+ type + " = " + this.enabledSearchTypes[type])
        return this.enabledSearchTypes[type]
      },
      allAvailableSearchTypes() {
        // Return all enabled search types
        const types = [];
        if (this.enabledSearchTypes.fulltext) types.push('fulltext');
        if (this.enabledSearchTypes['fulltext-all-fields']) types.push('fulltext-all-fields');
        if (this.enabledSearchTypes.englishDefinition) types.push('englishDefinition');
        if (this.enabledSearchTypes.definiendum) types.push('definiendum');
        if (this.enabledSearchTypes.definiendumStarts) types.push('definiendumStarts');
        if (this.enabledSearchTypes.definiendumExact) types.push('definiendumExact');
        if (this.enabledSearchTypes['translation-tool']) types.push('translation-tool');
        if (this.enabledSearchTypes['verb-tense']) types.push('verb-tense');
        if (this.enabledSearchTypes.definiendumLike) types.push('definiendumLike');
        if (this.enabledSearchTypes.definiendumRegex) types.push('definiendumRegex');
        if (this.enabledSearchTypes['monlam-englishToTibetan']) types.push('monlam-englishToTibetan');
        if (this.enabledSearchTypes['monlam-tibetanToEnglish']) types.push('monlam-tibetanToEnglish');
        if (this.enabledSearchTypes['monlam-tibetanToTibetan']) types.push('monlam-tibetanToTibetan');
        if (this.enabledSearchTypes['monlam-tibetanToTibetanOld']) types.push('monlam-tibetanToTibetanOld');
        return types;
      },
      // Methods for programmatic dropdown control (used by tutorial)
      openDropdown() {
        if (this.$refs.dropdownButton && window.$) {
          window.$(this.$refs.dropdownButton).dropdown('show');
        }
      },
      closeDropdown() {
        if (this.$refs.dropdownButton && window.$) {
          window.$(this.$refs.dropdownButton).dropdown('hide');
        }
      },
      getDropdownElement() {
        return this.$refs.searchTypeDropdown;
      }
  }
}
</script>

<style>
.wylie-key {
display: inline-block;
padding: 2px 2px;
background-color: lightgray;
margin:5px 5px;
border-radius: 5px;
width: 65px;
}

.wylie-key-tibetan {
font-size:24px;
}

.wylie-key-english {
font-size:18px;
}
</style>

<style scoped>
  #search-row {
    padding: 20px 0;
    text-align: center;
  }

  #search-column {
    background: #fffae2;
    padding: 50px 30px 30px 30px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
    min-width: 250px;
    margin-bottom: 30px;
  }


  #searchInput {
    margin: 0 auto;
  }

  #searchInput,
  #searchInput:active,
  #searchInput:focus {
    background-color: white !important;
  }

  input#searchInput.large-font {
    font-size: 1.8rem;
  }

  .recent-searches-dropdown-label {
    font-weight: bold; 
    padding: .25rem 1.5rem;   
    pointer-events: none;
    color: #a6a2a2;
    text-decoration: underline;
  }

  .search-reset {
    margin-left: 10px;
  }

  input[type=checkbox] {
    margin-right: 5px;
  }

  .compact-checkbox-container {
    text-align: left;
    margin: 20px;
  }

  .compact-checkbox-label {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .compact-checkbox-text {
    font-size: 0.95rem;
  }

  .search-type-explanation {
    font-size: 0.95rem;
    color: #a6a2a2;
    margin-top: 12px;
    padding: 8px 0;
  }

  .form-check-inline .form-check-input {
    margin-bottom: 5px;
  }

  .input-group.flex-wrap {
    flex-wrap: wrap;
  }


  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }

  /* Responsive styles */
  @media only screen and (max-device-width: 900px) {
    #search-row {
      margin-bottom: 10px;
    }
  }

  @media only screen and (max-device-width: 480px) {
    .input-group.flex-wrap .input-group-append {
      width: 100%;
      margin-top: 8px;
    }

    .input-group.flex-wrap .input-group-append .btn {
      width: 100%;
    }

    .input-group.flex-wrap {
      width: 100% !important;
      margin: 0 auto;
    }

    .input-group.flex-wrap .form-control {
      margin-bottom: 4px;
    }

    #search-row {
        margin-bottom: 10px;
    }

    #search-col {
        border-radius: 0px;
    }

    .input-group.flex-wrap .input-group-append {
      width: 100%;
      margin-top: 8px;
    }

    .input-group.flex-wrap .input-group-append .btn {
      width: 100%;
    }

    .input-group.flex-wrap {
      width: 100% !important;
      margin: 0 auto;
    }

    .input-group.flex-wrap .form-control {
      margin-bottom: 4px;
    }

    #search-column .form-group button[type="submit"] {
      width: 100%;
    }

    .search-reset[data-v-e32b15ce] {
      margin-left: 0px;
      margin-top: 10px;
      width: 100%;
    }

  }
</style>
